import React, { useState } from "react";
import { Image } from "semantic-ui-react";
import { assetTypeToPlaceholderIcon } from "services/common";

const AssetImage = ({ asset, type = asset.type, size = "massive" }) => {
  const [hasError, setHasError] = useState(false);

  const placeholder = assetTypeToPlaceholderIcon(type, size);

  return !asset || hasError || !asset.thumbnailUrl ? (
    placeholder
  ) : (
    <Image
      src={asset.thumbnailUrl}
      onError={() => setHasError(true)}
      alt={asset.name}
      style={{ maxWidth: "80%" }}
    />
  );
};

export default AssetImage;
